var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-btn",
    {
      attrs: {
        value: _vm.buttons["create"].Value,
        width: _vm.buttons["create"].Width,
      },
      on: { click: _vm.clicked },
    },
    [
      _vm.buttons["create"].Text
        ? _c("span", [_vm._v(" " + _vm._s(_vm.Text) + " ")])
        : _vm._e(),
      _c("v-icon", [_vm._v(" " + _vm._s(_vm.buttons["create"].Icon) + " ")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }